import React from 'react';
import { Fade } from 'react-awesome-reveal';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "../assets/css/testimonial.css";

// Import local images
import netLogo from '../assets/images/Technologies/net.png';
import AILogo from '../assets/images/Technologies/AI.png'; // Replace with actual local image path
import sapLogo from '../assets/images/Technologies/sap.png'; // Replace with actual local image path
import javaLogo from '../assets/images/Technologies/java.png'; // Replace with actual local image path
import oracleLogo from '../assets/images/Technologies/oracle.png'; // Replace with actual local image path
import awsLogo from '../assets/images/Technologies/aws.png'; // Replace with actual local image path

export default function Testimonial() {
  // Array of logo objects
  const logos = [
    { id: 1, imageUrl: netLogo, altText: 'Company 1' },
    { id: 2, imageUrl: AILogo, altText: 'Company 2' },
    { id: 3, imageUrl: sapLogo, altText: 'Company 3' },
    { id: 4, imageUrl: javaLogo, altText: 'Company 4' },
    { id: 5, imageUrl: oracleLogo, altText: 'Company 5' },
    { id: 6, imageUrl: awsLogo, altText: 'Company 6' },
  ];

  return (
    <section className="container mx-auto">
      <Fade direction="up" triggerOnce>
        <h1 className="text-5xl text-theme-White text-center font-bold">Our Technology Expertise</h1>
      </Fade>
      <Fade direction="up" delay={500}>
        <p className="font-light text-lg text-gray-400 text-center mb-3 sm:mb-3 xl:mb-4">
          We have extensive experience in a wide range of technologies, including:
        </p>
      </Fade>
      <div className="brandsCarousel">
        <div className="carouselTrack">
          {/* Render original logos */}
          {logos.map((logo) => (
            <div className="brandLogo" key={logo.id}>
              <img src={logo.imageUrl} alt={logo.altText} className="w-20 h-20" />
            </div>
          ))}
          {/* Render cloned logos for seamless looping */}
          {logos.map((logo) => (
            <div className="brandLogo" key={`clone-${logo.id}`}>
              <img src={logo.imageUrl} alt={logo.altText} className="w-20 h-20" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
